import React from 'react';
import client from '../../utils/eventEmit';
import { Link as MatLink } from '@material-ui/core';
const linkStyle = { color: '#38a4dc', cursor: 'pointer', textDecoration: 'none' };

export const getColumns: any = {
  PROVIDER: [
    {
      title: 'Service Name',
      field: 'workflowName',
      headerStyle: { zIndex: 11 },
      width: '15%',
      render: (rowData: any) => {
        return (
          <MatLink
            onClick={() => {
              window.history.pushState(
                '',
                '',
                `/participant/${window.location.pathname.split('/')[2]}/service/${rowData.workflowCode}`
              );
              client.emit('serviceCodeKey', rowData.workflowCode);
            }}
            style={linkStyle}
          >
            {rowData.workflowName}
          </MatLink>
        );
      }
    },
    {
      title: 'Customers',
      field: 'partnerCount',
      headerStyle: { zIndex: 11 },
      width: '10%',
      render: (rowData: any) => (rowData.partnerCount ? rowData.partnerCount : 0)
    },
    {
      title: 'Subscribed Limit',
      field: 'subscriptionLimit',
      headerStyle: { zIndex: 11 },
      width: '20%'
    },
    {
      title: 'Notification Threshold',
      field: 'subscriptionThreshold',
      headerStyle: { zIndex: 11 },
      width: '20%'
    },
    {
      title: '# of Errors Last Hour',
      field: 'lastHourErrorCount',
      headerStyle: { zIndex: 11 }
    },
    {
      title: '# of Errors Today',
      field: 'todayErrorCount',
      headerStyle: { zIndex: 11 }
    }
    // {
    //   title: 'Transaction Errors',
    //   field: 'errors',
    //   headerStyle: { zIndex: 11 },
    //   width: '20%',
    //   render: (rowData: any) => (rowData.errors ? rowData.errors : 0)
    // }
  ],
  CUSTOMER: [
    {
      title: 'Service Name',
      field: 'workflowName',
      headerStyle: { zIndex: 11 },
      width: '20%',
      render: (rowData: any) => {
        return (
          <MatLink
            onClick={() => {
              window.history.pushState(
                '',
                '',
                `/participant/${window.location.pathname.split('/')[2]}/service/${rowData.workflowCode}`
              );
              client.emit('serviceCodeKey', rowData.workflowCode);
            }}
            // to={`/participant/${window.location.pathname.split('/')[2]}/service/${rowData.workflowCode}`}
            style={linkStyle}
          >
            {rowData.workflowName}
          </MatLink>
        );
      }
    },
    {
      title: 'Providers',
      field: 'partnerCount',
      headerStyle: { zIndex: 11 },
      width: '20%',
      render: (rowData: any) => (rowData.partnerCount ? rowData.partnerCount : 0)
    },
    {
      title: '# of Errors Last Hour',
      field: 'lastHourErrorCount',
      headerStyle: { zIndex: 11 }
    },

    {
      title: '# of Errors Today',
      field: 'todayErrorCount',
      headerStyle: { zIndex: 11 }
    }
    // {
    //   title: 'Transaction Errors',
    //   field: 'errors',
    //   headerStyle: { zIndex: 11 },
    //   width: '20%',
    //   render: (rowData: any) => (rowData.errors ? rowData.errors : 0)
    // }
  ],
  AGGREGATOR: [
    {
      title: 'Service Name',
      field: 'workflowName',
      headerStyle: { zIndex: 11 },
      width: '15%',
      render: (rowData: any) => {
        return (
          <MatLink
            onClick={() => {
              window.history.pushState(
                '',
                '',
                `/participant/${window.location.pathname.split('/')[2]}/service/${rowData.workflowCode}`
              );
              client.emit('serviceCodeKey', rowData.workflowCode);
            }}
            style={linkStyle}
          >
            {rowData.workflowName}
          </MatLink>
        );
      }
    },
    {
      title: 'Providers',
      field: 'partnerCount',
      headerStyle: { zIndex: 11 },
      width: '10%',
      render: (rowData: any) => (rowData.partnerCount ? rowData.partnerCount : 0)
    },
    {
      title: 'Subscribed Limit',
      field: 'subscriptionLimit',
      headerStyle: { zIndex: 11 },
      width: '20%'
    },
    {
      title: 'Notification Threshold',
      field: 'subscriptionThreshold',
      headerStyle: { zIndex: 11 },
      width: '20%'
    },
    {
      title: '# of Errors Last Hour',
      field: 'lastHourErrorCount',
      headerStyle: { zIndex: 11 }
    },
    {
      title: '# of Errors Today',
      field: 'todayErrorCount',
      headerStyle: { zIndex: 11 }
    }
    // {
    //   title: 'Transaction Errors',
    //   field: 'errors',
    //   headerStyle: { zIndex: 11 },
    //   width: '20%',
    //   render: (rowData: any) => (rowData.errors ? rowData.errors : 0)
    // }
  ],
  CUSTOMER_AGGREGATOR: [
    {
      title: 'Service Name',
      field: 'workflowName',
      headerStyle: { zIndex: 11 },
      width: '15%',
      render: (rowData: any) => {
        return (
          <MatLink
            onClick={() => {
              window.history.pushState(
                '',
                '',
                `/participant/${window.location.pathname.split('/')[2]}/service/${rowData.workflowCode}`
              );
              client.emit('serviceCodeKey', rowData.workflowCode);
            }}
            style={linkStyle}
          >
            {rowData.workflowName}
          </MatLink>
        );
      }
    },
    {
      title: 'Customers',
      field: 'partnerCount',
      headerStyle: { zIndex: 11 },
      width: '10%',
      render: (rowData: any) => (rowData.partnerCount ? rowData.partnerCount : 0)
    },
    {
      title: 'Subscribed Limit',
      field: 'subscriptionLimit',
      headerStyle: { zIndex: 11 },
      width: '20%'
    },
    {
      title: 'Notification Threshold',
      field: 'subscriptionThreshold',
      headerStyle: { zIndex: 11 },
      width: '20%'
    },
    {
      title: '# of Errors Last Hour',
      field: 'lastHourErrorCount',
      headerStyle: { zIndex: 11 }
    },
    {
      title: '# of Errors Today',
      field: 'todayErrorCount',
      headerStyle: { zIndex: 11 }
    }
    // {
    //   title: 'Transaction Errors',
    //   field: 'errors',
    //   headerStyle: { zIndex: 11 },
    //   width: '20%',
    //   render: (rowData: any) => (rowData.errors ? rowData.errors : 0)
    // }
  ]
};

export default getColumns;
